/* eslint-disable */

// variables
let toggleClass = "active";

/* helper functions
**************************************************************/
function isTouchDevice() {
	return typeof window.ontouchstart !== "undefined";
}

/* isMobDevice
**************************************************************/
function isMobDevice() {
	let w =
		window.innerWidth ||
		document.documentElement.clientWidth ||
		document.body.clientWidth;

	return Boolean(w < 992);
}

/* function toggle elem visibility
**************************************************************/
function toggle(el) {
	el.style.display = el.style.display == "none" ? "block" : "none";
}

/* function to add active class for active item and remove class from siblings
**************************************************************/
const setActive = el => {
	[...el.parentElement.children].forEach(sib =>
		sib.classList.remove(toggleClass)
	);
	el.classList.add(toggleClass);
};

/* function show/hide match scores
**************************************************************/
function showHideScores(event) {
	const el = [...document.querySelectorAll(`#matches-${event} .match .match__score.has_result`)];
	if (el.length) {
		for (let i = 0; i < el.length; i++) {
			el[i].addEventListener("click", function() {
				toggle(el[i].lastElementChild);
				toggle(el[i].firstElementChild);
			});
		}
	}
}

/* function toggle Class
**************************************************************/
function toggleActive(elems, cls, event) {
	if (event == "remove") {
		elems.forEach(
			el => (el.classList.contains(cls) ? el.classList.remove(toggleClass) : "")
		);
	}

	if (event == "add") {
		elems.forEach(
			el =>
				el.classList.contains(cls)
					? el.classList.add(toggleClass)
					: el.classList.remove(toggleClass)
		);
	}

	if (event == "toggle") {
		elems.forEach(
			el =>
				el.classList.contains(cls)
					? el.classList.toggle(toggleClass)
					: el.classList.toggle(toggleClass)
		);
	}
}

/* function slideUp
**************************************************************/
let slideUp = (target, duration = 500) => {
	target.style.transitionProperty = "height, margin, padding";
	target.style.transitionDuration = duration + "ms";
	target.style.boxSizing = "border-box";
	target.style.height = target.offsetHeight + "px";
	target.offsetHeight;
	target.style.overflow = "hidden";
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	window.setTimeout(() => {
		target.style.display = "none";
		target.style.removeProperty("height");
		target.style.removeProperty("padding-top");
		target.style.removeProperty("padding-bottom");
		target.style.removeProperty("margin-top");
		target.style.removeProperty("margin-bottom");
		target.style.removeProperty("overflow");
		target.style.removeProperty("transition-duration");
		target.style.removeProperty("transition-property");
	}, duration);
};

/* function slideDown
**************************************************************/
let slideDown = (target, useDisplay = "block", duration = 500) => {
	target.style.removeProperty("display");
	let display = window.getComputedStyle(target).display;
	display = useDisplay === "" ? "block" : useDisplay;

	if (display === "none") display = useDisplay;

	target.style.display = display;
	let height = target.offsetHeight;
	target.style.overflow = "hidden";
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.offsetHeight;
	target.style.boxSizing = "border-box";
	target.style.transitionProperty = "height, margin, padding";
	target.style.transitionDuration = duration + "ms";
	target.style.height = height + "px";
	target.style.removeProperty("padding-top");
	target.style.removeProperty("padding-bottom");
	target.style.removeProperty("margin-top");
	target.style.removeProperty("margin-bottom");
	window.setTimeout(() => {
		target.style.removeProperty("height");
		target.style.removeProperty("overflow");
		target.style.removeProperty("transition-duration");
		target.style.removeProperty("transition-property");
	}, duration);
};

/* function SlideToggle
**************************************************************/
var slideToggle = (target, duration = 500) => {
	if (window.getComputedStyle(target).display === "none") {
		return slideDown(target, duration);
	} else {
		return slideUp(target, duration);
	}
};

/* function isInDOM
**************************************************************/
var isInDOM = function(element, inBody) {
	var _ = element,
		last;

	while (_) {
		last = _;
		if (inBody && last === document.body) {
			break;
		}
		_ = _.parentNode;
	}

	return inBody ? last === document.body : last === document;
};

/* Get all siblings of an element
**************************************************************/
let getSiblings = function(elem) {
	let siblings = [];
	let sibling = elem.parentNode.firstChild;

	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== elem) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling;
	}

	return siblings;
};

/* test time for AJAX request
**************************************************************/
function testAjaxRequest(startTime, requestName) {
	var request_time = new Date().getTime() - startTime;
	var seconds = (request_time / 1000).toFixed(3);

	var restime =	"AJAX " +	requestName + " request took " + seconds + " seconds to complete.";
	return restime;
}

/* Function to get next day format "YYYY-MM-DD"
**************************************************************/
function getNextDay(day, number) {
	return moment(day).add(number,'days').format('YYYY-MM-DD');
}

/* Function to get prev day format "YYYY-MM-DD"
**************************************************************/
function getPrevDay(day, number) {
	return moment(day).add(number,'days').format('YYYY-MM-DD');
}

/* Function to set Cookie
**************************************************************/
function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var path = "path=/",
			expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + "; " + path + ";" + expires;
}

/* Function to set Cookie
**************************************************************/
function getCookie(cname) {
	let name = cname + '=';
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for(let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return null;
}


/* Function to set user timezone
**************************************************************/
if (!getCookie('esg_timezone')) {
	let cookie = "esg_timezone";
	let exdays = 7;
	let d = new Date();
	let timez = d.getTimezoneOffset() / 60;

	setCookie(cookie, timez, exdays);
}


/* Function to get week day
**************************************************************/
Date.prototype.getWeekDay = function() {
	var weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
	return weekday[this.getDay()];
}


/* Function for adding the ordinal suffix, turning 1, 2 and 3 into 1st, 2nd and 3rd
**************************************************************/
Number.prototype.addSuffix=function(){
	var n=this.toString().split('.')[0];
	var lastDigits=n.substring(n.length-2);
	//add exception just for 11, 12 and 13
	if(lastDigits==='11' || lastDigits==='12' || lastDigits==='13'){
			return this+'th';
	}
	switch(n.substring(n.length-1)){
			case '1': return this+'st';
			case '2': return this+'nd';
			case '3': return this+'rd';
			default : return this+'th';
	}
};

/* Check if children is the last element
**************************************************************/
function isLastChild(el) {
  return (el === el.parentNode.children[el.parentNode.children.length-1]) 
}

/* Check if children is the first element
**************************************************************/
function isFirstChild(el) {
  return (el === el.parentNode.firstElementChild) 
}


/* Check if element is visible
**************************************************************/
function isVisible(ele) {
	var style = window.getComputedStyle(ele);
	return (
		style.width !== "0" &&
		style.height !== "0" &&
		style.opacity !== "0" &&
		style.display !== "none" &&
		style.visibility !== "hidden"
	);
}


/* function to check status (live, upcoming, ended)
**************************************************************/
function checkLiveMatches(container) {
  let id = container.getAttribute('data-tournament');

	$.ajax({
		type: "POST",
		url: themeVars.adminUrl,
		data: {
      action: "tournament_status",
      id: id,
		},
		beforeSend: function() {
		},
		success: function(response) {
      let labels = container.querySelectorAll(`.status_label`);

      for(let i = 0; i < labels.length; i++) {
        if(labels[i].classList.contains(`${response}`)) {
          labels[i].classList.remove('hide');
        } else {
          labels[i].remove();
        }
      }
		},
	});
}


/* Funtion toggle mask when click mobile menu
**************************************************************/
function toggleMaskVisibility() {
	if (isMobDevice()) {
		let buttons = document.querySelectorAll('.button-icon.active');
		let mask = document.querySelector('.mask');
		if (buttons.length > 0) {
			mask.classList.add(toggleClass);
		} else {
			mask.classList.remove(toggleClass);
		}
	}
}

/* disable/enable loading
**************************************************************/
function showLoading(container, flag) {
	if(container !== null) {
		let loading = container.querySelector('.loading');
		if(loading !== null) {
			if (flag === true) {
				loading.classList.add(toggleClass);
			} else {
				loading.classList.remove(toggleClass);
			}
		}
	}
}

/* add filter data into array to pass to php to load filtered the list of matches
**************************************************************/
function addRemove(array, string) {
	if (array.indexOf(string) == -1) {
		array.push(string);
	} else {
		array.splice($.inArray(string, array), 1);
	}
}

export {
	toggle,
	setActive,
	showHideScores,
	toggleActive,
	isTouchDevice,
	slideToggle,
	slideDown,
	slideUp,
	isInDOM,
	getSiblings,
	isMobDevice,
	testAjaxRequest,
	getNextDay,
	getPrevDay,
	setCookie,
	getCookie,
	isLastChild,
	isFirstChild,
	isVisible,
	checkLiveMatches,
	toggleMaskVisibility,
	showLoading,
	addRemove,
};



// WEBPACK FOOTER //
// ./scripts/modules/helpers.js